import {Component} from '@angular/core';

@Component({
  selector: 'generic-error-snackbar',
  templateUrl: './generic-error-snackbar.component.html',
  styleUrls: ['./generic-error-snackbar.component.scss'],
})
export class GenericErrorSnackbarComponent {}
